










































































































































































































































import LookUp from '@/components/lookup/Index.vue'
import { genericErrorMessage } from '@/constants'
import { EventBus, ON_SEARCH_PAGE_CREATE, ON_SEARCH_PAGE_DELETE, ON_SEARCH_PAGE_EDIT, TRIGGER_SEARCH } from '@/eventbus'
import { clientService, userService } from '@/services'
import { Role } from '@/types/UserServiceType'
import { BaseSearchOption } from '@/types/utilTypes'
import { cloneDeep, debounce } from 'lodash'
import Vue from 'vue'


function generateInitialUpdateForm() {
    return {
        user: {
            username: '',
            firstName: '',
            lastName: '',
            isActive: false,
            roles: {} as Record<string, boolean>,
        },
        dialog: false,
        error: '',
        success: false,
        loading: false,
    }
}

function generateInitialUserRemoveForm(){
    return {
        loading: false,
        success: false,
        error: false,
        dialog: false,
        user: { username: ''}
    }
}

export default Vue.extend({
    name: 'User',
    components: {
        LookUp
    },
    async created() {
        this.debouncedGetUsersNotInClient = debounce(this.getUsersNotInClient.bind(this), 700)
    },
    async mounted() {
        await this.getAvailableRoles()
        EventBus.$on(ON_SEARCH_PAGE_EDIT, (pageName:string, payload: any) => {
            if(pageName === this.$store.getters.currentPageConfig.pageName) { 
                this.onUserEdit(payload)
            }
        })

        EventBus.$on(ON_SEARCH_PAGE_CREATE, (pageName: string) => {
            if(pageName === this.$store.getters.currentPageConfig.pageName) { 
                this.addUsersForm.addUsersDialog = true
                this.debouncedGetUsersNotInClient(this.addUsersTableSearch)
            }
        })

        EventBus.$on(ON_SEARCH_PAGE_DELETE, (pageName: string, payload: any) => {
            if(pageName === this.$store.getters.currentPageConfig.pageName) { 
                this.removeUserInClientForm = generateInitialUserRemoveForm()
                this.removeUserInClientForm.user = payload
                this.removeUserInClientForm.dialog = true
            }
        })
    },
    destroyed() {
        EventBus.$off()
    },
    data(){
        return {
            availableRoles: [] as Role[],
            updateForm: generateInitialUpdateForm(),
            addUsersForm: {
                error:false,
                success: false,
                addUsersDialog: false,
                users: [] as any,
                headers: [
                    { text: 'Username', value: 'username'}, 
                    { text:'Email', value: 'email'},
                    { text: 'First Name', value: 'firstName'},
                    { text: 'Last Name', value: 'lastName'},
                    { text: 'Actions', value: 'actions', sortable: false },
                ],
                totalRecords: 0,
                addLoading: false,
                fetchLoading: false
            },
            removeUserInClientForm: generateInitialUserRemoveForm() ,
            // Separated for performance
            addUserSortBy: '',
            addUserSortDesc: false,
            addUsersTableSearch: {
                keywords: '',
                pageIndex: 1,
                pageSize: 10,
                order: '',
                timeZoneOffsetInMinutes: -420
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            debouncedGetUsersNotInClient: debounce((_search: BaseSearchOption) => {return}, 500),
            genericErrorMessage
        }
    },
    methods: {
        generateRolesDict() {
            return this.availableRoles.reduce<Record<string,boolean>>((prev, curr) => {
                prev[curr.id] = false
                return prev
            }, {})
        },
        async onUserEdit(item: any) {
            this.onUpdateCancel()
            this.updateForm.user = {...item, roles: this.updateForm.user.roles}
            const userRoles = await userService.getUserRoles(item.username)
            userRoles.forEach(uRole => this.updateForm.user.roles[uRole.id] = true)
            this.updateForm.dialog = true
        },
        onUpdateCancel() {
            this.updateForm = generateInitialUpdateForm()
            this.updateForm.user.roles = this.generateRolesDict()
        },
        onRoleUpdate(value: boolean, role: Role) {
            this.updateForm.user.roles[role.id] = value
        },
        async onUpdateSave() {
            this.updateForm.error = ''
            this.updateForm.success = false
            this.updateForm.loading = true

            const temp = cloneDeep(this.updateForm.user)
            
            try {
                await userService.updateUser({...temp , roles: Object.keys(temp.roles).filter(o=>temp.roles[o])})
                this.updateForm.success = true
            } catch (error) {
                this.updateForm.error = genericErrorMessage
            } finally{ 
                this.updateForm.loading = false
            }
            EventBus.$emit(TRIGGER_SEARCH)
        },
        async getAvailableRoles() {
            this.availableRoles = await userService.getAvailableRoles()
            this.updateForm.user.roles = this.generateRolesDict()
        },
        async getUsersNotInClient(search: BaseSearchOption) {
            this.addUsersForm.fetchLoading = true
            try {
                const data = await clientService.getUsersNotInClient(search)
                this.addUsersForm.users = data.records
                this.addUsersForm.totalRecords = data.totalRecords
            } catch(e) {
                this.addUsersForm.users = []
                this.addUsersForm.totalRecords = 0
            }
            this.addUsersForm.fetchLoading = false
        },
        async onAddUserToClient(userId: string) {
            this.addUsersForm.error = false
            this.addUsersForm.success = false
            this.addUsersForm.addLoading = true

            try {
                await clientService.addUsersToClient({ users: [userId] })
                await this.debouncedGetUsersNotInClient(this.addUsersTableSearch)
                this.addUsersForm.success = true
                
                EventBus.$emit(TRIGGER_SEARCH)
            }  catch(_) {
                this.addUsersForm.error = true
            }

            this.addUsersForm.addLoading = false
        },
        async onRemoveUsersInClient(userId: string) {
            this.removeUserInClientForm.error = false
            this.removeUserInClientForm.success = false
            this.removeUserInClientForm.loading = true

            try {
                await clientService.removeUsersInClient({ users: [userId]})
                this.removeUserInClientForm.success = true
                EventBus.$emit(TRIGGER_SEARCH)
            } catch(_) {
                this.removeUserInClientForm.error = true
            }

            this.removeUserInClientForm.loading = false
        },
        onRemoveUserCancel() {
            this.removeUserInClientForm = generateInitialUserRemoveForm()
        },
        resetUserAddForm() {
            this.addUsersForm.addLoading = false
            this.addUsersForm.success = false
            this.addUsersForm.error = false
        }
    },
    computed: {
        groupedRoles(): any[] {
            const groupedItems = [] as any[]
            const size = 3
            for (let i = 0; i < this.availableRoles.length; i += size) {
                groupedItems.push(this.availableRoles.slice(i, i+size))
            }
            return groupedItems
        },
        newUserTableOrder(): string {
            const alias = this.addUsersForm.headers.find(x => x.value == this.addUserSortBy)?.text || ''
            return `${alias} ${this.addUserSortDesc ? 'desc' : ''}`.trim()
        }
    },
    watch: {
        newUserTableOrder(newValue) {
            this.addUsersTableSearch.order = newValue
        },
        addUsersTableSearch:{
            async handler(newValue){
                await this.debouncedGetUsersNotInClient(newValue)
            },
            deep:true,
        }
        
    },
})
